import React from 'react';
import DisModal from './design-system/DisModal';
import DisButton from './design-system/DisButton';

const WeeklyRecapModal = ({ recap, onDismiss }) => {
  if (!recap) return null;

  return (
    <DisModal isOpen={true} onClose={onDismiss} title="">
      <div className="text-center space-y-4 py-2" data-testid="weekly-recap-modal">
        <h2 className="text-2xl font-bold text-gray-800" style={{ fontFamily: "'Caveat', cursive" }}>
          La semaine de {recap.child_name} &#127775;
        </h2>

        <div className="grid grid-cols-2 gap-3">
          <div className="bg-blue-50 rounded-xl p-3">
            <p className="text-2xl font-bold text-blue-600">{recap.questions_count}</p>
            <p className="text-xs text-blue-400">Questions posées</p>
          </div>
          <div className="bg-purple-50 rounded-xl p-3">
            <p className="text-2xl font-bold text-purple-600">{recap.quizzes_count}</p>
            <p className="text-xs text-purple-400">Quiz complétés</p>
          </div>
          <div className="bg-amber-50 rounded-xl p-3">
            <p className="text-2xl font-bold text-amber-600">{recap.stars_earned}</p>
            <p className="text-xs text-amber-400">Étoiles gagnées</p>
          </div>
          {recap.new_badges.length > 0 && (
            <div className="bg-green-50 rounded-xl p-3">
              <p className="text-2xl font-bold text-green-600">{recap.new_badges.length}</p>
              <p className="text-xs text-green-400">Nouveau{recap.new_badges.length > 1 ? 'x' : ''} badge{recap.new_badges.length > 1 ? 's' : ''}</p>
            </div>
          )}
        </div>

        {recap.best_question && (
          <div className="bg-gray-50 rounded-xl p-3">
            <p className="text-xs text-gray-400 mb-1">Meilleure question de la semaine</p>
            <p className="text-sm text-gray-700 italic">« {recap.best_question} »</p>
          </div>
        )}

        <DisButton
          onClick={onDismiss}
          className="w-full bg-gradient-to-r from-teal-500 to-emerald-500 text-white font-medium"
          data-testid="recap-continue-btn"
        >
          Continuer l'aventure
        </DisButton>
      </div>
    </DisModal>
  );
};

export default WeeklyRecapModal;
